import React from 'react';
import clsx from 'clsx';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import amber from '@material-ui/core/colors/amber';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import { NotificationProps, NotificationVariant } from './notification-types';

export const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles<string, { color: 'black' | 'white' }>({
      success: {
        backgroundColor: green[600],
      },
      error: {
        backgroundColor: theme.palette.error.dark,
      },
      info: {
        backgroundColor: grey[300],
      },
      warning: {
        backgroundColor: amber[700],
      },
      icon: ({ color }) => ({
        fontSize: 20,
        color,
      }),
      iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(1),
      },
      message: ({ color }) => ({
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'pre-line',
        fontWeight: 400,
        color,
      }),
    }),
  { index: 1 }
);

/**
 * Notification.
 */
export function Notification({
  open,
  message,
  variant,
  onClose,
}: NotificationProps) {
  const classes = useStyles({
    color: variant === NotificationVariant.INFO ? 'black' : 'white',
  });

  const Icon = variantIcon[variant];

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      style={{
        bottom: 20,
      }}
      open={open}
    >
      <SnackbarContent
        className={classes[variant]}
        aria-describedby="client-snackbar"
        message={
          <span id="client-snackbar" className={classes.message}>
            <Icon className={clsx(classes.icon, classes.iconVariant)} />
            {message}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={onClose}
          >
            <CloseIcon className={classes.icon} />
          </IconButton>,
        ]}
      />
    </Snackbar>
  );
}
